import React, { useState } from 'react';
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";

const ContactSection = () => {


    const [contactFormData, setContactFormData] = useState({
        email: '',
        message: ''
    });
    const [isContactLoading, setIsContactLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    const handleContactFormChange = (e) => {
        const { name, value } = e.target;
        setContactFormData({
            ...contactFormData,
            [name]: value
        });
    };

    const handleContactFormSubmit = async (e) => {
        e.preventDefault();
        setIsContactLoading(true);
        setSuccessMessage('');
        try {
            const response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/v1/einvoice/send-email', contactFormData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                setContactFormData({ email: '', message: '' });
                setSuccessMessage('The message was successfully sent!');
            } else {
                console.log('Error occurred while sending the email.');
                setSuccessMessage('The message was not sent, please try again later :(');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            setSuccessMessage('The message was not sent, please try again later :(');
        } finally {
            setIsContactLoading(false);
        }
    };
    

    return (
        <section id="contact" className="subscribe-section pt-5 pb-5 text-white">
            <div className="container">
                <div className="subscribe-wrapper p-4 rounded bg-light shadow">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <div className="section-title mb-4">
                                <h2 className="mb-3 text-dark">Contact us</h2>
                                <p className="text-dark">
                                    Contact us if you want us to add another e-invoice format or if you have any questions.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <form onSubmit={handleContactFormSubmit} className="contact-form">
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label text-dark">Your Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        placeholder="Your Email"
                                        className="form-control border-primary"
                                        value={contactFormData.email}
                                        onChange={handleContactFormChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label text-dark">Message</label>
                                    <textarea
                                        name="message"
                                        id="message"
                                        placeholder="Message"
                                        className="form-control border-primary"
                                        rows="4"
                                        value={contactFormData.message}
                                        onChange={handleContactFormChange}
                                        required
                                    ></textarea>
                                </div>
                                <div className="d-flex align-items-center">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isContactLoading}
                                    >
                                        {isContactLoading ? 'Sending...' : 'Send'}
                                    </button>
                                    {successMessage && (
                                        <div className="alert alert-success ms-3 d-flex align-items-center">
                                            <FaCheckCircle size="30" className="me-2" /> {successMessage}
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
